import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';


@Component({
  selector: 'shared-norecords-found',
  standalone: true,
  imports: [CommonModule,TranslocoModule],
  templateUrl: './norecords-found.component.html',
  styleUrl: './norecords-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NorecordsFoundComponent {}
